export const usageData = [
  {
    id: 0,
    title: 'Launch',
    isFeatured: false,
    features: [
      { id: 1, name: 'Groups', value: 1 },
      { id: 2, name: 'Sites', value: 1 },
      { id: 3, name: 'Users', value: 1 },
    ],
  },
  {
    id: 1,
    title: 'Essential',
    isFeatured: true,
    features: [
      { id: 1, name: 'Groups', value: 5 },
      { id: 2, name: 'Sites', value: 50 },
      { id: 3, name: 'Users', value: 10 },
    ],
  },
  {
    id: 2,
    title: 'Premium',
    isFeatured: false,
    features: [
      { id: 1, name: 'Groups', value: 10 },
      { id: 2, name: 'Sites', value: 100 },
      { id: 3, name: 'Users', value: 20 },
    ],
  },
  {
    id: 3,
    title: 'Enterprise',
    isFeatured: false,
    features: [
      { id: 1, name: 'Groups', value: 50 },
      { id: 2, name: 'Sites', value: 500 },
      { id: 3, name: 'Users', value: 100 },
    ],
  },
]
